// extracted by mini-css-extract-plugin
module.exports = {"annal":"Video_annal__3KBoW","text":"Video_text__3ghk3","fjdsioj2":"Video_fjdsioj2__1mYyC","content":"Video_content__2qJXK"};